import React, { useEffect, useState } from 'react'
import { Table, Button, Modal, Input } from 'antd'
import { EyeOutlined, SlackOutlined } from '@ant-design/icons'
import axiosInstance from '../../Utils/axiosInstance'
import dayjs from 'dayjs'
import { toast } from 'react-toastify'

import {
  GetOrdersDataAPI,
  UpdateApprovalOrdersDataAPI,
} from '../../AllAPI/AdminAPI'

const OrderApproval = () => {
  const selectedYear = Number(sessionStorage.getItem('year'))
  /* ================= LIST ================= */
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(false)
  const [actionLoadingId, setActionLoadingId] = useState(null)
  const [approveLoading, setApproveLoading] = useState(false)

  /* ================= APPROVAL MODAL ================= */
  const [approveModalOpen, setApproveModalOpen] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [approvalItems, setApprovalItems] = useState([])

  useEffect(() => {
    fetchApprovalOrders()
  }, [])

  /* ================= FETCH ================= */
  const fetchApprovalOrders = async () => {
    try {
      setLoading(true)
      const res = await axiosInstance.get(`${GetOrdersDataAPI}/${selectedYear}`)
      const data = Array.isArray(res.data) ? res.data : []
      setOrders(data)
    } finally {
      setLoading(false)
    }
  }

  /* ================= OPEN APPROVE MODAL ================= */
  const openApproveModal = (order) => {
    setSelectedOrder(order)

    const mapped = order.orders.map((o) => ({
      prod_id: o.prod_id,
      product_name: o.product_name,

      quantity: o.quantity,
      rate: o.rate,

      approve_qty: o.approval_status === 1 ? o.approval_quantity : o.quantity,
      approve_rate: o.approval_status === 1 ? o.approval_rate : o.rate,

      approval_status: o.approval_status || 0,
      checked: o.approval_status === 1,
    }))

    setApprovalItems(mapped)
    setApproveModalOpen(true)
  }

  /* ================= UPDATE ROW ================= */
  const updateItem = (index, key, value) => {
    const copy = [...approvalItems]
    copy[index][key] = value
    setApprovalItems(copy)
  }

  /* ================= APPROVE SUBMIT ================= */
  // const handleApprove = async () => {
  //   const payload = {
  //     date: dayjs().format('YYYY-MM-DD'),
  //     cust_id: selectedOrder.cust_id,
  //     items: approvalItems.map((i) => ({
  //       prod_id: i.prod_id,
  //       quantity: i.quantity,
  //       rate: i.rate,
  //       approval_quantity: i.approval_status === 1 ? i.approve_qty : i.quantity,
  //       approval_rate: i.approval_status === 1 ? i.approve_rate : i.rate,
  //       approval_status: i.approval_status,
  //     })),
  //   }

  //   try {
  //     const res = await axiosInstance.put(
  //       `${UpdateApprovalOrdersDataAPI}/${selectedOrder.order_id}`,
  //       payload,
  //     )
  //     if (res.data == 'ORDERAPPROVAL') {
  //       toast.success('Order approved successfully')
  //       setApproveModalOpen(false)
  //       fetchApprovalOrders()
  //     }
  //   } catch {
  //     toast.error('Approval failed')
  //   }
  // }

  const handleApprove = async () => {
    // order-level status
    const orderStatus = approvalItems.some((i) => i.approval_status === 1)
      ? 1
      : 0

    const payload = {
      date: dayjs().format('YYYY-MM-DD'),
      cust_id: selectedOrder.cust_id,
      status: orderStatus,
      year: selectedYear,
      items: approvalItems.map((i) => ({
        prod_id: i.prod_id,
        quantity: i.quantity,
        rate: i.rate,
        approval_quantity: i.approval_status === 1 ? i.approve_qty : i.quantity,
        approval_rate: i.approval_status === 1 ? i.approve_rate : i.rate,
        approval_status: i.approval_status,
      })),
    }

    try {
      setApproveLoading(true)
      const res = await axiosInstance.put(
        `${UpdateApprovalOrdersDataAPI}/${selectedOrder.order_id}`,
        payload,
      )

      if (res.data === 'ORDERAPPROVAL') {
        toast.success('Order approved successfully')
        setApproveModalOpen(false)
        fetchApprovalOrders()
      }
    } catch {
      toast.error('Approval failed')
    } finally {
      setApproveLoading(false)
    }
  }

  /* ================= MAIN TABLE ================= */
  const orderColumns = [
    {
      title: 'Sr No',
      align: 'center',
      render: (_, __, index) => index + 1,
    },
    { title: 'Customer', dataIndex: 'customer_name' },
    {
      title: 'Status',
      render: (_, record) =>
        record.status === 1 ? (
          <span style={{ color: 'green', fontWeight: 600 }}>Approved</span>
        ) : (
          <span style={{ color: 'orange', fontWeight: 500 }}>Pending</span>
        ),
    },
    // {
    //   title: 'Action',
    //   render: (_, record) => (
    //     <Button
    //       type="primary"
    //       size="small"
    //       title="Action"
    //       icon={<EyeOutlined />}
    //       onClick={() => openApproveModal(record)}
    //     >
    //       Action
    //     </Button>
    //   ),
    // },
    {
      title: 'Action',
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          icon={<EyeOutlined />}
          loading={actionLoadingId === record.order_id}
          onClick={() => {
            setActionLoadingId(record.order_id)
            openApproveModal(record)
            setActionLoadingId(null)
          }}
        >
          Action
        </Button>
      ),
    },
  ]

  /* ================= APPROVAL TABLE ================= */
  const approvalColumns = [
    {
      title: '✔',
      render: (_, r, i) => (
        <input
          type="checkbox"
          checked={r.checked}
          onChange={(e) => {
            const checked = e.target.checked
            updateItem(i, 'checked', checked)
            updateItem(i, 'approval_status', checked ? 1 : 0)

            if (!checked) {
              updateItem(i, 'approve_qty', r.quantity)
              updateItem(i, 'approve_rate', r.rate)
            }
          }}
        />
      ),
    },
    { title: 'Product', dataIndex: 'product_name' },
    { title: 'Order Qty', dataIndex: 'quantity' },
    {
      title: 'Approve Qty',
      render: (_, r, i) => (
        <Input
          type="number"
          disabled={!r.checked}
          value={r.approve_qty}
          onChange={(e) => updateItem(i, 'approve_qty', Number(e.target.value))}
        />
      ),
    },
    { title: 'Rate (₹)', dataIndex: 'rate' },
    {
      title: 'Approve Rate (₹)',
      render: (_, r, i) => (
        <Input
          type="number"
          disabled={!r.checked}
          value={r.approve_rate}
          onChange={(e) =>
            updateItem(i, 'approve_rate', Number(e.target.value))
          }
        />
      ),
    },
  ]

  return (
    <>
      <div className="mainContainer">
        <div className="header-row">
          <h3>
            <SlackOutlined style={{ color: 'orangered' }} /> Order Approval
          </h3>
        </div>

        <Table
          columns={orderColumns}
          dataSource={orders}
          rowKey="order_id"
          loading={loading}
          bordered
          className="shadow"
          style={{ overflowX: 'auto' }}
        />
      </div>

      {/* ================= APPROVE MODAL ================= */}
      <Modal
        title="Approve Order"
        open={approveModalOpen}
        onCancel={() => setApproveModalOpen(false)}
        onOk={handleApprove}
        okText="Save"
        width={900}
        okButtonProps={{
          loading: approveLoading,
        }}
      >
        <div className="row mb-2">
          <div className="col-md-6">
            <Input value={selectedOrder?.customer_name} disabled />
          </div>
          <div className="col-md-6">
            <Input value={dayjs().format('DD-MM-YYYY')} disabled />
          </div>
        </div>

        <Table
          columns={approvalColumns}
          dataSource={approvalItems}
          rowKey="prod_id"
          pagination={false}
          bordered
          style={{ overflowX: 'auto' }}
        />
      </Modal>
    </>
  )
}

export default OrderApproval
